import { Heading } from "@/storybook-components";

import type { QuickPollVariant } from "@/types";

interface HeadingProps {
  name?: string;
  variant?: QuickPollVariant;
}

const PollHeading = ({ name, variant }: HeadingProps): JSX.Element => {
  const isWidget = variant === "widget";

  return (
    <Heading
      as={isWidget ? "h3" : "h2"}
      size={isWidget ? "md" : "lg"}
      mb={0}
      className="ehq-quickPollTitle"
    >
      {name}
    </Heading>
  );
};

export default PollHeading;
